import { render } from "./DictionaryImportModal.vue?vue&type=template&id=2b006e8f"
import script from "./DictionaryImportModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DictionaryImportModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Captioning/DictionaryImportModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b006e8f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b006e8f', __exports__)) {
    api.reload('2b006e8f', __exports__)
  }
  
  module.hot.accept("./DictionaryImportModal.vue?vue&type=template&id=2b006e8f", () => {
    api.rerender('2b006e8f', render)
  })

}


export default __exports__